import { Button, Typography, Card, CardActions } from '@mui/material';
import { useSnackbar, SnackbarContent, CustomContentProps } from "notistack";
import { makeStyles } from "@mui/styles";

import React, { useState, forwardRef, useCallback, useEffect } from "react";


const useStyles = makeStyles(() => ({
    root: {
        "@media (min-width:600px)": {
            minWidth: "344px !important"
        }
    },
    card: {
        width: "100%",
        backgroundColor: "darkred",
    },
    typography: {
        color: "white"
    },
    actionRoot: {
        padding: "8px 8px 8px 16px",
        justifyContent: "space-between"
    },
    icons: {
        marginLeft: "auto"
    },
    expand: {
        padding: "8px 8px",
        transform: "rotate(0deg)",
        color: "#000",
        transition: "all .2s"
    },
    expandOpen: {
        transform: "rotate(180deg)"
    },
    paper: {
        backgroundColor: "#fff",
        padding: 16
    },
    checkIcon: {
        fontSize: 20,
        paddingRight: 4
    },
    button: {
        padding: 0,
        textTransform: "none"
    },

}));


interface FormAlertProps extends CustomContentProps {
    open: boolean;
    onClose: () => void;
    onView: () => void;
    dialogContent: React.ReactNode;
    // allowDownload: boolean;
    Form: React.ComponentType<any>;
    dataForm: any;
}

export const FormAlert = forwardRef<HTMLDivElement, FormAlertProps>((props, ref) => {

    const {
        id,
        message,
        Form,
        dataForm,
    } = props

    const { closeSnackbar } = useSnackbar();
    const classes = useStyles();

    const onCancel = useCallback(() => {
        closeSnackbar(id);
    }, [id, closeSnackbar]);


    const [data, setData] = useState({})
    const [openModal, setOpenModal] = useState(false)

    const handleCloseAgregar = () => {
        onCancel()
        setOpenModal(false)
    }


    const onSubmit = () => {
        setOpenModal(true)
    }

    useEffect(() => {
        setData({
            ...dataForm,
            openModal: openModal,
            handleCloseModal: handleCloseAgregar,
            onCancel: handleCloseAgregar,
            setOpen: setOpenModal
        })
    }, [openModal])

    return (
        <SnackbarContent ref={ref}
            className={classes.root}
        >
            <Card className={classes.card} >
                <CardActions classes={{ root: classes.actionRoot }}>
                    <Typography
                        variant="body2"
                        className={classes.typography}
                    >
                        {message}
                    </Typography>

                    <Button className={classes.button} color="primary" variant="contained" size="small" onClick={() => onSubmit()}>
                        Revisar
                    </Button>
                    <Button className={classes.button} color="secondary" variant="contained" size="small" onClick={onCancel}>
                        Descartar
                    </Button>

                </CardActions>
                <Form {...data} />
            </Card>
        </SnackbarContent>
    );
})